import useCurrentProviderTypeName from '@app/src/hooks/currentProviderTypeName'
import { ProgressTracker } from '@app/src/types/resourceExplorer'
import { br } from '@app/src/utils/translationMarkup'
import { RadarOutlined } from '@mui/icons-material'
import { Stack, Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'

interface TargetElementProps {
  progressTracker?: ProgressTracker
}

const TargetElement = ({ progressTracker }: TargetElementProps) => {
  const { formatMessage } = useIntl()
  const resourceType = useCurrentProviderTypeName({ isPlural: true })

  return (
    <Stack height="100%" justifyContent="space-between">
      <Stack spacing={1} textAlign="center" alignItems="center" justifyContent="center" height="100%">
        <RadarOutlined />
        {!progressTracker ? (
          <Typography variant="body1">{formatMessage({ id: 'schemas.progressTracker.noDataYet' })}</Typography>
        ) : (
          <>
            <Typography variant="kpi" lineHeight={1}>
              {progressTracker.totalCompaniesInScope}
            </Typography>
            <Typography variant="body1">
              {formatMessage(
                { id: 'schemas.progressTracker.targetElement' },
                {
                  resourceType,
                  scopeTargetPeriodName: progressTracker.scopeTargetPeriodName,
                  br,
                  b: (chunks: React.ReactNode) => <b>{chunks}</b>,
                },
              )}
            </Typography>
          </>
        )}
      </Stack>
    </Stack>
  )
}

export default TargetElement
